/* RunRun 2026-09-08 · Consola de diagnóstico en pantalla.
   INERTE salvo que la URL traiga ?rrdebug=1. Persiste en localStorage para
   sobrevivir a una caída del renderer de Safari (que es lo que sospechamos). */
(function () {
  try {
    if (!/[?&]rrdebug=1/.test(location.search)) return;
    var KEY = 'rr_dbg_log';
    var log = [];
    try { log = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { log = []; }

    var t0 = Date.now();
    function push(kind, msg) {
      var e = { t: ((Date.now() - t0) / 1000).toFixed(1), k: kind, m: String(msg).slice(0, 300) };
      log.push(e);
      if (log.length > 200) log = log.slice(-200);
      try { localStorage.setItem(KEY, JSON.stringify(log)); } catch (x) {}
      render();
    }

    /* ---- captura ---- */
    window.addEventListener('error', function (ev) {
      if (ev.target && ev.target !== window && ev.target.tagName) {
        push('RES', ev.target.tagName + ' no cargó: ' + (ev.target.src || ev.target.href || '').slice(-70));
      } else {
        push('ERR', (ev.message || '') + ' @' + (ev.filename || '').split('/').pop() + ':' + ev.lineno);
      }
    }, true);

    window.addEventListener('unhandledrejection', function (ev) {
      var r = ev.reason;
      push('REJ', (r && (r.message || r)) || 'promesa rechazada');
    });

    var ce = console.error;
    console.error = function () {
      try { push('CON', Array.prototype.join.call(arguments, ' ')); } catch (x) {}
      return ce.apply(console, arguments);
    };

    var of = window.fetch;
    if (of) {
      window.fetch = function () {
        var u = String(arguments[0] && arguments[0].url ? arguments[0].url : arguments[0] || '');
        return of.apply(this, arguments).then(function (r) {
          if (!r.ok) push('NET', r.status + ' ' + u.slice(-70));
          return r;
        }, function (err) {
          push('NET', 'FALLÓ ' + u.slice(-70) + ' · ' + (err && err.message));
          throw err;
        });
      };
    }

    /* ---- vigía de la grilla: esto es lo que buscamos ---- */
    var lastPainted = -1, lastH = -1;
    function cards() { return document.querySelectorAll('product-card, [class*="product-card"]'); }
    function checkGrid(why) {
      var list = cards(), painted = 0;
      for (var i = 0; i < list.length; i++) {
        var r = list[i].getBoundingClientRect();
        if (r.height > 4 && r.width > 4) painted++;
      }
      var grid = document.querySelector('results-list, .product-grid, [class*="results-list"]');
      var h = grid ? Math.round(grid.getBoundingClientRect().height) : -1;
      if (lastPainted >= 0) {
        var colapso = (painted === 0 && lastPainted > 0) || (h >= 0 && lastH > 200 && h < lastH * 0.75);
        if (colapso) {
          push('GRID', '⚠️ tarjetas ' + lastPainted + '→' + painted + ' · alto ' + lastH + '→' + h + 'px · ' + why);
          /* la prueba: ¿las tarjetas y sus slides se colapsaron a 0 por content-visibility? */
          try {
            for (var j = 0; j < Math.min(3, list.length); j++) {
              var c = list[j], cs = getComputedStyle(c);
              var sl = c.querySelector('slideshow-slide');
              var ss = sl ? getComputedStyle(sl) : null;
              push('CV', 'card' + j + ' h=' + Math.round(c.getBoundingClientRect().height) +
                ' cv=' + cs.contentVisibility + ' cis=' + cs.containIntrinsicSize +
                (ss ? ' | slide h=' + Math.round(sl.getBoundingClientRect().height) +
                      ' cv=' + ss.contentVisibility + ' cis=' + ss.containIntrinsicSize +
                      ' hidden=' + sl.getAttribute('aria-hidden') : ' | sin slide'));
            }
          } catch (x) { push('CV', 'no se pudo leer: ' + x); }
        }
      }
      lastPainted = painted; lastH = h;
    }
    function snapshot(why) {
      var list = cards(), painted = 0;
      for (var i = 0; i < list.length; i++) {
        var r = list[i].getBoundingClientRect();
        if (r.height > 4 && r.width > 4) painted++;
      }
      var grid = document.querySelector('results-list, .product-grid, [class*="results-list"]');
      var h = grid ? Math.round(grid.getBoundingClientRect().height) : -1;
      push('SNAP', why + ' · tarjetas ' + painted + '/' + list.length + ' pintadas · grilla ' + h + 'px · scrollY=' + Math.round(scrollY));
      try {
        for (var j = 0; j < Math.min(4, list.length); j++) {
          var c = list[j], cs = getComputedStyle(c);
          var sl = c.querySelector('slideshow-slide');
          var ss = sl ? getComputedStyle(sl) : null;
          push('CV', 'card' + j + ' h=' + Math.round(c.getBoundingClientRect().height) +
            ' cv=' + cs.contentVisibility + ' cis=' + cs.containIntrinsicSize +
            (ss ? ' | slide h=' + Math.round(sl.getBoundingClientRect().height) +
                  ' cv=' + ss.contentVisibility + ' cis=' + ss.containIntrinsicSize : ' | sin slide'));
        }
      } catch (x) { push('CV', 'error: ' + x); }
    }
    window.__rrSnap = snapshot;

    /* traza continua: registra el alto de la grilla mientras se hace scroll,
       aunque no haya colapso. Solo cuando cambia >10% o pasaron 3s. */
    var tick = 0, lastTrace = 0, lastTraceH = -1;
    addEventListener('scroll', function () {
      if (++tick % 4) return;
      checkGrid('scroll y=' + Math.round(scrollY));
      var grid = document.querySelector('results-list, .product-grid, [class*="results-list"]');
      var h = grid ? Math.round(grid.getBoundingClientRect().height) : -1;
      var list = cards(), painted = 0;
      for (var i = 0; i < list.length; i++) {
        var r = list[i].getBoundingClientRect();
        if (r.height > 4 && r.width > 4) painted++;
      }
      var now = Date.now();
      var cambio = lastTraceH < 0 || Math.abs(h - lastTraceH) > lastTraceH * 0.1;
      if (cambio || now - lastTrace > 3000) {
        lastTrace = now; lastTraceH = h;
        push('TRZ', 'y=' + Math.round(scrollY) + ' grilla=' + h + 'px tarjetas=' + painted + '/' + list.length);
        if (painted < list.length) snapshot('faltan tarjetas');
      }
    }, { passive: true });
    setInterval(function () { checkGrid('reloj'); }, 1500);

    /* ---- ciclo de vida: si Safari mata la pestaña, esto lo delata al volver ---- */
    addEventListener('pagehide', function (e) { push('VIDA', 'pagehide persisted=' + e.persisted); });
    addEventListener('pageshow', function (e) { push('VIDA', 'pageshow persisted=' + e.persisted); });
    document.addEventListener('visibilitychange', function () { push('VIDA', 'visibility=' + document.visibilityState); });

    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    push('INIT', 'carga=' + (nav ? nav.type : '?') + ' · ' + (matchMedia('(max-width:749px)').matches ? 'móvil' : 'desktop') + ' · ' + location.pathname);

    /* ---- UI ---- */
    var box, pre, open = true;
    function render() {
      if (!box) return;
      pre.textContent = log.slice(-60).map(function (e) { return e.t + 's ' + e.k + ' ' + e.m; }).join('\n');
      pre.scrollTop = pre.scrollHeight;
      box.querySelector('.rrn').textContent = log.length;
    }
    function build() {
      box = document.createElement('div');
      box.setAttribute('style', 'position:fixed;left:0;right:0;bottom:0;z-index:2147483647;background:rgba(12,12,12,.94);color:#fedb00;font:11px/1.35 ui-monospace,Menlo,monospace;border-top:2px solid #fedb00;');
      box.innerHTML = '<div style="display:flex;gap:8px;align-items:center;padding:6px 10px;border-bottom:1px solid #333">' +
        '<b style="color:#fff">RR DEBUG</b><span class="rrn" style="color:#fff">0</span>' +
        '<button class="rrc" style="margin-left:auto;background:#fedb00;color:#111;border:0;padding:4px 8px;font-weight:700">COPIAR</button>' +
        '<button class="rrs" style="background:#c00;color:#fff;border:0;padding:4px 8px;font-weight:700">CAPTURAR</button>' +
        '<button class="rrx" style="background:#333;color:#fff;border:0;padding:4px 8px">LIMPIAR</button>' +
        '<button class="rrt" style="background:#333;color:#fff;border:0;padding:4px 8px">▼</button></div>' +
        '<pre class="rrp" style="margin:0;padding:8px 10px;max-height:34vh;overflow:auto;white-space:pre-wrap;word-break:break-word"></pre>';
      document.body.appendChild(box);
      pre = box.querySelector('.rrp');
      box.querySelector('.rrc').onclick = function () {
        var txt = log.map(function (e) { return e.t + 's ' + e.k + ' ' + e.m; }).join('\n');
        if (navigator.clipboard) navigator.clipboard.writeText(txt);
        this.textContent = 'COPIADO';
      };
      box.querySelector('.rrs').onclick = function () { snapshot('CAPTURA MANUAL'); };
      box.querySelector('.rrx').onclick = function () { log = []; try { localStorage.removeItem(KEY); } catch (x) {} render(); };
      box.querySelector('.rrt').onclick = function () {
        open = !open; pre.style.display = open ? 'block' : 'none'; this.textContent = open ? '▼' : '▲';
      };
      render();
    }
    if (document.body) build(); else addEventListener('DOMContentLoaded', build);
  } catch (e) { /* jamás romper el sitio por el debug */ }
})();
